import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { CustomFieldsAdmin } from "@/pages/admin/CustomFieldsAdmin";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/custom-fields",
  component: () => (
    <RoleGuard action="custom_field_crud">
      <CustomFieldsAdmin />
    </RoleGuard>
  ),
});
